<template>
    <div class="sfbz">
        <div class="sfbzcontent">
            <van-empty description="暂无数据" v-if="list.length==0"/>
            <div class="bz">
                <div class="bzitem" v-for="(item,index) in list" :key="index">
                    <div style="width:80px">
                        <span>{{item.chargeType}}：</span>
                    </div>
                    <div class="xz">
                        <span>{{item.ruleName}}</span>
                        <span>{{item.ruleContent}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list:[
                {
                    name:'名字1',
                    money:'123'
                }
            ]
        }
    },
    mounted() {
        this.$axios.get('/api/v1/wygl/charge/gtrules/'+sessionStorage.getItem('houseId')).then(res => {
        	this.list=res;
        })
    },
    methods: {
        
    },
}
</script>
<style lang="less" scoped>
    .sfbz{
        .sfbzcontent{
            margin: 5%;
        }
        .bz{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            border-radius: 10px;
            box-shadow: 0 0 10px #dadada;
            .bzitem{
                width: 90%;
                border-bottom: #e7e7e7 1px solid ;
                display: flex;
                align-items: flex-start;
                padding: 10px 0;
                .xz{
                    display: flex;
                    flex-direction: column;
                }
            }
        }
    }
</style>